import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AdminProducts from '@/views/AdminProducts.vue'
import ManageAppProgressView from '@/views/ManageAppProgressView.vue'
import StaffProducts from '@/views/StaffProducts.vue'
import StaffProductDetail from '@/views/StaffProductDetail.vue'
import StaffDashboardView from '@/views/StaffDashboardView.vue'
import StaffLeads from '@/views/StaffLeads.vue'
import StaffOnboardCustomerView from '@/views/StaffOnboardCustomerView.vue'
import StaffPaymentsView from '@/views/StaffPaymentsView.vue'
import StaffTemplates from '@/views/StaffTemplates.vue'
import StaffManageSettingsView from '@/views/StaffManageSettingsView.vue'
import { onAuthStateChanged } from 'firebase/auth'
import { doc, getDoc } from 'firebase/firestore'
import { auth, db } from '@/firebase'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/CustomerDashboardView.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdminDashboardView.vue')
  },
  {
    path: '/admin/customers/:id',
    name: 'admin-customer-detail',
    component: () => import('../views/CustomerDetailView.vue'),
    props: true
  },
  {
    path: '/admin-settings',
    name: 'admin-settings',
    component: () => import('../views/AdminSettingsView.vue')
  },
  {
    path: '/admin-revenue-reports',
    name: 'admin-revenue-reports',
    component: () => import('../views/AdminRevenueReportsView.vue'),
    meta: { requiresAuth: true, role: 'admin' }
  },
  {
    path: '/customer-settings',
    name: 'customer-settings',
    component: () => import('../views/CustomerSettingsView.vue')
  },
  {
    path: '/admin/templates',
    name: 'admin-templates',
    component: () => import('../views/AdminTemplates.vue')
  },
  {
    path: '/why',
    name: 'why',
    component: () => import('../views/WhyView.vue')
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('../views/ServicesView.vue')
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('../views/DemoView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('../views/ResetPasswordView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/manage-app-progress',
    name: 'ManageAppProgress',
    component: ManageAppProgressView
  },
  { 
    path: '/admin/products', 
    name: 'AdminProducts', 
    component: AdminProducts, 
    meta: { requiresAuth: true, role: 'admin' } 
  },
  { 
    path: '/admin/products/:id', 
    name: 'AdminProductDetail', 
    component: StaffProductDetail, 
    props: true 
  },
  { 
    path: '/staff/products/:id', 
    name: 'StaffProductDetail', 
    component: StaffProductDetail, 
    props: true, 
    meta: { requiresAuth: true, role: 'staff' } 
  },
  {
    path: '/staff/products',
    name: 'StaffProducts',
    component: StaffProducts,
    meta: { requiresAuth: true, role: 'staff' }
  },
  {
    path: '/staff-dashboard',
    name: 'StaffDashboard',
    component: StaffDashboardView,
    meta: { requiresAuth: true, role: 'staff' }
  },
  {
    path: '/staff-leads',
    name: 'staff-leads',
    component: StaffLeads,
    meta: { requiresAuth: true, role: 'staff' }
  },
  {
    path: '/staff-onboard-customer',
    name: 'staff-onboard-customer',
    component: StaffOnboardCustomerView,
    meta: { requiresAuth: true, role: 'staff' }
  },
  {
    path: '/staff-payments',
    name: 'staff-payments',
    component: StaffPaymentsView,
    meta: { requiresAuth: true, role: 'staff' }
  },
  {
    path: '/staff/templates',
    name: 'staff-templates',
    component: StaffTemplates,
    meta: { requiresAuth: true, role: 'staff' }
  },
  {
    path: '/staff-manage-settings',
    name: 'staff-manage-settings',
    component: StaffManageSettingsView,
    meta: { requiresAuth: true, role: 'staff' }
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import(/* webpackChunkName: "blog" */ '../views/BlogView.vue')
  },
  {
    path: '/blog/:slug',
    name: 'blog-post',
    component: () => import(/* webpackChunkName: "blog" */ '../views/BlogPostView.vue'),
    props: true
  },
  {
    path: '/staff-blog',
    name: 'staff-blog',
    component: () => import('../views/StaffBlogManageView.vue'),
    meta: { requiresAuth: true, role: 'staff' }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue')
  },
  {
    path: '/cookies',
    name: 'cookies',
    component: () => import('../views/CookieView.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../views/TermsView.vue')
  },
  {
    path: '/security',
    name: 'security',
    component: () => import('../views/SecurityView.vue')
  },
  {
    path: '/documentation',
    name: 'documentation',
    component: () => import('../views/DocumentationView.vue')
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/HelpCenterView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// ─────────────────────────────────────────────────────────────────────────
// Auth state tracking for the route guard below.
//
// THE BUG THIS FIXES: on every page refresh, auth.currentUser is
// synchronously null for a brief moment while Firebase restores the
// persisted session from IndexedDB — that restore is inherently async, even
// though the session itself is genuinely still valid. The old guard read
// auth.currentUser directly, saw null, and redirected straight to /login —
// which looked exactly like "the user gets logged out on every refresh"
// even though Firebase's session persistence was working fine the whole
// time. onAuthStateChanged fires once Firebase actually knows the real
// state (and again on every subsequent login/logout), so the guard now
// waits for that first callback before making any redirect decision.
//
// This also now checks the user's role (users/{uid}.role in Firestore —
// 'Admin' / 'Staff' / 'Customer', same convention as assertIsStaff() in the
// Cloud Functions and routeByRole() in LoginView.vue) against each route's
// meta.role ('admin' / 'staff', lowercase). Previously meta.role was never
// read anywhere, so any signed-in user — including a Customer — could
// navigate straight to a staff-only route and the page would attempt to
// load. Firestore/Storage rules already block the underlying data in that
// case, but the page itself shouldn't render at all for the wrong role.
// ─────────────────────────────────────────────────────────────────────────
let currentUser = null
let currentRole = null
let authReady = false
let resolveAuthReady
const authReadyPromise = new Promise((resolve) => { resolveAuthReady = resolve })

onAuthStateChanged(auth, async (user) => {
  currentUser = user

  if (user) {
    try {
      const snap = await getDoc(doc(db, 'users', user.uid))
      currentRole = snap.exists() ? (snap.data().role || null) : null
    } catch (e) {
      console.error('Error fetching user role for route guard:', e)
      currentRole = null
    }
  } else {
    currentRole = null
  }

  if (!authReady) {
    authReady = true
    resolveAuthReady()
  }
})

function roleSatisfies(requiredRole, actualRole) {
  if (!requiredRole) return true
  if (!actualRole) return false
  const req = requiredRole.toLowerCase()
  const actual = actualRole.toLowerCase()
  if (req === actual) return true
  // Admin can access anything a Staff-only route allows.
  if (req === 'staff' && actual === 'admin') return true
  return false
}

router.beforeEach(async (to, from, next) => {
  // Wait for Firebase's first real answer about auth state before making
  // any redirect decision — see note above for why this matters on refresh.
  if (!authReady) await authReadyPromise

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiredRole = to.matched.map(record => record.meta.role).find(Boolean)

  if (requiresAuth && !currentUser) {
    next('/login')
  } else if (requiresAuth && requiredRole && !roleSatisfies(requiredRole, currentRole)) {
    next('/')
  } else if (to.path === '/login' && currentUser) {
    next('/')
  } else {
    next()
  }
})

export default router